import { useQuery, useMutation, useQueryClient, UseQueryResult, UseMutationResult } from '@tanstack/react-query';

import { QueryOption } from '../@types';
import { NotificationTemplate, NotificationTemplatePaginateListResponse, SendGridTemplate } from '../@types/notificationTamplate.type';
import { createNotificationTemplate, getNotificationTemplateById, getNotificationTemplatesPaginated, getSendGridTemplates, updateNotificationTemplate } from '../api/notificationTemplate';
import { NotificationTemplateKey, SendGridTemplateKey } from '../configs/notificationTemplate';

export const useGetAllNotificationTemplatesPaginated = (queryOption: QueryOption): UseQueryResult<NotificationTemplatePaginateListResponse> => {
  return useQuery({
    queryKey: [NotificationTemplateKey, queryOption.page, queryOption.pageSize],
    queryFn: () => getNotificationTemplatesPaginated(queryOption)
  });
};

export const useGetNotificationTemplate = (id: number): UseQueryResult<NotificationTemplate | undefined> => {
  return useQuery({
    queryKey: [NotificationTemplateKey, id],
    queryFn: () => getNotificationTemplateById(id),
    enabled: id !== 0
  });
};

export const useCreateNotificationTemplate = (): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await createNotificationTemplate(data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [NotificationTemplateKey]
      });
    }
  });
};

export const useUpdateNotificationTemplate = (): UseMutationResult => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      await updateNotificationTemplate(data.id, data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [NotificationTemplateKey]
      });
    }
  });
};

export const useGetSendGridTemplates = (): UseQueryResult<SendGridTemplate[]> => {
  return useQuery({
    queryKey: [SendGridTemplateKey],
    queryFn: () => getSendGridTemplates()
  });
};